/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/require-default-props */
import closeIco from 'assets/images/close-btn-black.svg';
import modalImg from 'assets/images/modals/PayoutsFees.svg';
import { useTranslation } from 'providers/GILT.provider';

import Button from 'settings/page-elements/Button';

const PaymentFeesModal = ({ btnClose, popupTitle, btnName, closeModal, onClickButton, disabled, children }) => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="overlay" />
      <div className="confirmation-modal payment-fees animated zoomIn">
        <div className="modal-body">
          <span className={btnClose ? 'close hidden' : 'close'} onClick={closeModal}>
            <img src={closeIco} alt="Close modal" />
          </span>
          <h2 className="modal-title"> {popupTitle}</h2>

          <div className="modal-content">
            <img src={modalImg} alt="" className="modal-img" />
            <div className="text-gray">
              <span>{t('onlineBooking.generalSettings.businessStripeAccount.paymentFeesModal.description1Part1')}</span>
              <span>{t('onlineBooking.generalSettings.businessStripeAccount.paymentFeesModal.description1Part2')}</span>
            </div>

            <ul>
              <li>{t('onlineBooking.generalSettings.businessStripeAccount.paymentFeesModal.description2Part1')}</li>
              <li>{t('onlineBooking.generalSettings.businessStripeAccount.paymentFeesModal.description2Part2')}</li>
            </ul>
            {children}
          </div>
          <div className="modal-footer">
            <div className="text-in-footer sm">
              <span>{t('onlineBooking.generalSettings.businessStripeAccount.paymentFeesModal.description3Part1')}</span>
              <span>{t('onlineBooking.generalSettings.businessStripeAccount.paymentFeesModal.description3Part2')}</span>
            </div>
            <Button className="btn-violet" buttonName={btnName} onClickButton={onClickButton} disabled={disabled} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentFeesModal;
